import { FiscalType } from '../../enums/fiscalTypeEnum'

export const getCertificateRegistrationImage = (fiscalType: string) => {
  const ft = Number(fiscalType)
  return {
    label: {
      eng: ft === FiscalType.IP
        ? 'Scan of registration document*'
        : ft === FiscalType.JSC
        ? 'Scan certificate. state JSC registration*'
        : ft === FiscalType.PJSC
        ? 'Scan certificate. state PJSC registration*'
        : ft === FiscalType.CJSC
        ? 'Scan certificate. state CJSC registration*'
        : ft === FiscalType.LLP
        ? 'Scan certificate. state LLP registration*'
        : 'Scan certificate. state LLP registration*',
      rus: ft === FiscalType.IP
        ? 'Скан свид. гос. регистрации ИП*'
        : ft === FiscalType.JSC
        ? 'Скан свид. гос. регистрации АО*'
        : ft === FiscalType.PJSC
        ? 'Скан свид. гос. регистрации ПАО*'
        : ft === FiscalType.CJSC
        ? 'Скан свид. гос. регистрации ЗАО*'
        : ft === FiscalType.LLP
        ? 'Скан свид. гос. регистрации ТОО*'
        : 'Скан свид. гос. регистрации ООО*',
      kz: ft === FiscalType.IP
        ? 'Сканерлеу сертификаты. күй IP тіркеу*'
        : ft === FiscalType.JSC
        ? 'Сканерлеу сертификаты. күй АҚ тіркеу*'
        : ft === FiscalType.PJSC || ft === FiscalType.CJSC
        ? 'Сканерлеу сертификаты. күй ЖАҚ тіркеу*'
        : ft === FiscalType.LLP
        ? 'Сканерлеу сертификаты. күй ЖШС тіркеу*'
        : 'Сканерлеу сертификаты. күй ЖШС тіркеу*',
    },
    placeholder: {
      eng: 'Select or drag a file',
      rus: 'Выберите или перетащите файл',
      kz: 'Файлды таңдаңыз немесе сүйреңіз',
    },
  }
}
